module.exports = __webpack_public_path__ + "assets/0a66b92582e950709147c43758ce6a29.svg";